import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import type {
  HandoffOnlyPhoneNotificationsSettings,
  UpdateHandoffOnlyPhoneNotificationsInput,
} from "@school-sales-ai/shared";
import { api } from "@/lib/api";
import { useScopedClientId } from "@/hooks/useScopedClientId";

const PATH = "/crm/whatsapp/handoff-only-notifications";

/** «Avisar solo a partir del handoff» (WhatsApp → Teléfonos de notificación). */
export function useHandoffOnlyPhoneNotifications() {
  const clientId = useScopedClientId();
  return useQuery({
    queryKey: ["handoff-only-phone-notifications", clientId],
    queryFn: () => api.get<HandoffOnlyPhoneNotificationsSettings>(PATH),
    enabled: !!clientId,
  });
}

export function useUpdateHandoffOnlyPhoneNotifications() {
  const queryClient = useQueryClient();
  const clientId = useScopedClientId();
  return useMutation({
    mutationFn: (input: UpdateHandoffOnlyPhoneNotificationsInput) =>
      api.put<HandoffOnlyPhoneNotificationsSettings>(PATH, input),
    onSuccess: (data) => {
      queryClient.setQueryData(["handoff-only-phone-notifications", clientId], data);
      toast.success("Configuración guardada.");
    },
    onError: (err: Error) => toast.error(err.message),
  });
}
